// ============================================================
// Datei: src/pages/ressorts/programm/ProgrammMobile.jsx
//
// Zweck:
// - Mobile-Ansicht für das Ressort Programm
// - zeigt Libellen, Helferpool, Schichtplan und Gästeliste
//
// ÄNDERUNGEN:
// - Schichtplan wie bei Kasse aktualisierbar gemacht
// - Backstagebetreuung und Kanal K als eigene Schichtbereiche
// - autoRefresh bei ShiftTable wieder aktiviert
// - filterFn ergänzt, damit nach Auto-Refresh nur die passende
//   Untergruppe angezeigt wird
// - sichere Prüfung mit Array.isArray(shifts)
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import VolunteerPool from "../../../components/VolunteerPool";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./programmMobile.css";

const ProgrammMobile = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers,
	setSelectedVolunteer,
	downloadCcEmails
}) => {

	// ============================================================
	// STATE
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);
	const [helpersSubTab, setHelpersSubTab] = useState("ressort");

	// ============================================================
	// Sichere Shift-Liste
	// ============================================================
	const safeShifts = Array.isArray(shifts) ? shifts : [];

	// ============================================================
	// Hilfsfunktion:
	// Prüft, ob eine Schicht innerhalb eines ID-Bereichs liegt.
	// ============================================================
	const isShiftIdBetween = (shift, min, max) => {
		const shiftId = Number(shift?.shiftId);
		return shiftId >= min && shiftId <= max;
	};

	// ============================================================
	// Schichtgruppen Programm
	// ============================================================
	const backstagebetreuungShifts = safeShifts.filter((shift) =>
		isShiftIdBetween(shift, 900, 919)
	);

	const kanalKShifts = safeShifts.filter((shift) =>
		isShiftIdBetween(shift, 920, 949)
	);

	// ============================================================
	// Tabs
	// ============================================================
	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((tab) => (
						<button
							key={tab.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === tab.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(tab.id)}
						>
							{tab.label}
						</button>
					))}
				</div>

				<div className="tab-panels">

					{/* ====================================================
					    Tab: Libellen
					   ==================================================== */}
					{activeTab === "helpers" && (
						<div className="programm-mobile-helpers-panel">
							<div className="helpers-subtab-bar">
								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "ressort"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("ressort")}
								>
									Ressort
								</button>

								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "pool"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("pool")}
								>
									Helferpool
								</button>
							</div>

							{helpersSubTab === "ressort" && (
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={setSelectedVolunteer}
									reloadVolunteers={reloadVolunteers}
								/>
							)}

							{helpersSubTab === "pool" && (
								<VolunteerPool
									departmentName="Programm"
									onAssigned={() => {
										if (reloadVolunteers) {
											reloadVolunteers();
										}
									}}
								/>
							)}
						</div>
					)}

					{/* ====================================================
					    Tab: Schichtplan

					    Wichtig:
					    - Gleiches Prinzip wie bei Kasse.
					    - autoRefresh ist true.
					    - filterFn verhindert, dass nach dem Neuladen beide
					      Gruppen zusammen angezeigt werden.
					   ==================================================== */}
					{activeTab === "shifts" && (
						<div className="programm-shifts-panel">

							<section className="programm-shift-section">
								<h2 className="programm-subheading">
									Backstagebetreuung
								</h2>

								<ShiftTable
									shifts={backstagebetreuungShifts}
									departmentName="Programm"
									autoRefresh={true}
									filterFn={(shift) =>
										Number(shift?.shiftId) >= 900 &&
										Number(shift?.shiftId) <= 919
									}
								/>
							</section>

			{/*				<section className="programm-shift-section">
								<h2 className="programm-subheading">
									Kanal K
								</h2>

								<ShiftTable
									shifts={kanalKShifts}
									departmentName="Programm"
									autoRefresh={true}
									filterFn={(shift) =>
										Number(shift?.shiftId) >= 920 &&
										Number(shift?.shiftId) <= 949
									}
								/>
							</section>
			*/}

						</div>
					)}

					{/* ====================================================
					    Tab: Gästeliste
					   ==================================================== */}
					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(guest) => setGuestToEdit(guest)}
								onDelete={(guest) => setGuestToDelete(guest)}
							/>
						</>
					)}

					{/* ====================================================
					    Tab: Extrawürscht
					   ==================================================== */}
				{/*	{activeTab === "extras" && (
						<div
							className="cc-mail-card"
							onClick={downloadCcEmails}
							role="button"
							tabIndex={0}
							onKeyDown={(event) => {
								if (event.key === "Enter" || event.key === " ") {
									downloadCcEmails();
								}
							}}
						>
							<span className="cc-mail-icon">✉️</span>

							<div className="cc-mail-text">
								<span className="cc-mail-title">
									CC-Liste Helferfest herunterladen
								</span>
								<span className="cc-mail-subtitle">
									Für Outlook &amp; Gmail geeignet
								</span>
							</div>
						</div>
					)}
				*/}
				</div>
			</div>

			{/* ============================================================
			    Modal: Gast bearbeiten
			   ============================================================ */}
			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{/* ============================================================
			    Modal: Gast löschen
			   ============================================================ */}
			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default ProgrammMobile;